import styled from "styled-components";
import React, { useState } from "react";
import { Formik, Form as FormikForm } from "formik";
import * as yup from "yup";
import axios from "axios";
import { Link } from "react-router-dom";
import { useProductContext } from "../../context/ProductContext";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useNavigate } from "react-router-dom";

const initialValues = {
  name: "",
  email: "",
  password: "",
  district: "",
  upazila: "",
  address: "",
};

const schema = yup.object().shape({
  name: yup.string().required("Customer Name is a required field!"),
  email: yup.string().required("Customer Phone is a required field!"),
  password: yup.string().required("Password is a required field!"),
  district: yup.string().required("Customer District is a required field!"),
  upazila: yup.string().required("Customer Upazila is a required field!"),
  address: yup.string().required("Customer Address is a required field!"),
});

const validate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = "Phone or Username is required!";
  } else if (/^[0-9\b]+$/.test(values.email) === false) {
    errors.email = "Only number!";
  } else if (values.email.length !== 11) {
    errors.email = "Mobile Number contains 11 digit!";
  }

  if (!values.password) {
    errors.password = "Password is required!";
  } else if (values.password.length < 4) {
    errors.password = "Password is too short!";
  }
  return errors;
};

const RegistrationForm = () => {
  const Base_URL = process.env.REACT_APP_BASE_URL;
  const Register_URL = process.env.REACT_APP_REGISTER_URL;
  const Customer_Register_Post_URL = `${Base_URL}${Register_URL}`;

  const { district, upazila } = useProductContext();
  const navigate = useNavigate();
  const [message, setMessage] = useState();

  const AddRegFunc = async (values) => {
    let formfield = new FormData();

    // Append individual fields
    formfield.append("name", values.name);
    formfield.append("email", values.email);
    formfield.append("password", values.password);
    formfield.append("district", values.district);
    formfield.append("upazila", values.upazila);
    formfield.append("address", values.address);

    await axios({
      method: "POST",
      url: Customer_Register_Post_URL,
      headers: {
        "Content-Type": "application/json; charset=UTF-8; text/plain",
      },
      data: formfield,
    })
      .then((response) => {
        navigate("/login");
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
        setMessage(error.response.data.email);
      });
  };

  const submitRegisterForm = async (
    values,
    { setErrors, setSubmitting, resetForm }
  ) => {
    try {
      AddRegFunc(values);
      setSubmitting(false);
      // resetForm();
    } catch (error) {
      setErrors({ error: error.message });
    }
  };

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedUpazila, setSelectedUpazila] = useState("");

  const handleDistrictChange = (e) => {
    const selectedDistrictName = e.target.value;
    setSelectedDistrict(
      district.find((district) => district.name === selectedDistrictName)
    );
    setSelectedUpazila("");
  };

  const handleUpazilaChange = (e) => {
    const selectedUpazilaName = e.target.value;
    setSelectedUpazila(
      upazila.find((upazila) => upazila.name === selectedUpazilaName)
    );
  };

  return (
    <Wrapper>
      <div className="container col-lg-6 col-md-6 col-sm-10 mobileView">
        <h3>Account Register</h3>
        <hr />
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={submitRegisterForm}
          validate={validate}
        >
          {({
            handleSubmit,
            handleChange,
            isSubmitting,
            values,
            errors,
            touched,
          }) => (
            <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
              <div className="checkout-box">
                <div className="checkout-customer">
                  <Form.Group className="form-outline mb-3">
                    <Form.Label>
                      Customer Name<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="text"
                        name="name"
                        id="name"
                        value={values.name}
                        onChange={handleChange}
                        isInvalid={!!touched.name && !!errors.name}
                        isValid={touched.name && !errors.name}
                        className="form-control"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-3 ">
                    <Form.Label>
                      District<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Select
                        name="district"
                        id="district"
                        value={selectedDistrict ? selectedDistrict.name : ""}
                        onChange={(e) => {
                          handleChange(e);
                          handleDistrictChange(e);
                        }}
                        isInvalid={!!touched.district && !!errors.district}
                        isValid={touched.district && !errors.district}
                        className="form-control"
                      >
                        <option value="">Select</option>
                        {district &&
                          district.map((d, i) => {
                            return (
                              <option value={d.name} key={i}>
                                {d.name}-{d.bn_name}
                              </option>
                            );
                          })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.district}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-3 ">
                    <Form.Label>
                      Upazila<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Select
                        name="upazila"
                        id="upazila"
                        value={selectedUpazila ? selectedUpazila.name : ""}
                        onChange={(e) => {
                          handleChange(e);
                          handleUpazilaChange(e);
                        }}
                        isInvalid={!!touched.upazila && !!errors.upazila}
                        isValid={touched.upazila && !errors.upazila}
                        className="form-control"
                      >
                        <option value="">Select</option>
                        {upazila &&
                          upazila
                            .filter(
                              (upazila) =>
                                upazila.district ===
                                (selectedDistrict ? selectedDistrict.id : null)
                            )
                            .map((upazila) => {
                              return (
                                <option key={upazila.id} value={upazila.name}>
                                  {upazila.name}-{upazila.bn_name}
                                </option>
                              );
                            })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.upazila}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-3 ">
                    <Form.Label>
                      Customer Address<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        as="textarea"
                        name="address"
                        id="address"
                        value={values.address}
                        onChange={handleChange}
                        isInvalid={!!touched.address && !!errors.address}
                        isValid={touched.address && !errors.address}
                        className="form-control"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.address}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-3 ">
                    <Form.Label>
                      Phone<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="text"
                        name="email"
                        id="email"
                        value={values.email}
                        onChange={handleChange}
                        isInvalid={!!touched.email && !!errors.email}
                        isValid={touched.email && !errors.email}
                        className="form-control"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-3 ">
                    <Form.Label>
                      Password<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="password"
                        name="password"
                        id="password"
                        value={values.password}
                        onChange={handleChange}
                        isInvalid={!!touched.password && !!errors.password}
                        isValid={touched.password && !errors.password}
                        className="form-control"
                        autoComplete="on"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </div>
              </div>

              <div className="hstack gap-4 flex-wrap justify-content-center d-print-none my-3">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="normal"
                >
                  Register
                </button>
                <button className="normal">
                  <Link to="/login" style={{ textDecoration: "none" }}>
                    Login
                  </Link>
                </button>
              </div>
              <p
                style={{
                  textAlign: "center",
                  color: "red",
                  fontSize: "15px",
                  textTransform: "capitalize",
                }}
              >
                {message}
              </p>
            </FormikForm>
          )}
        </Formik>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  form {
    max-width: 400px;
    margin: 0 auto;
  }

  div {
    margin-bottom: 15px;
  }

  label {
    display: block;
    margin-bottom: 5px;
  }

  input,
  select,
  textarea {
    width: 100%;
    padding: 8px;
    margin-bottom: 8px;
    border: 1px solid black;
    border-radius: 4px;
  }

  label {
    font-weight: bold;
    margin-bottom: 10px !important;
  }

  span {
    color: red;
  }

  button,
  a {
    color: black;
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  button,
  a:hover {
    color: white;
  }

  .error {
    color: red;
    margin-top: 5px;
  }

  .container {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px green;
    max-width: 400px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 80px;
  }

  @media (max-width: 477px) {
    .mobileView {
      width: 80%;
    }
  }
`;

export default RegistrationForm;
